module.exports = __webpack_public_path__ + "ced946df09c6628dd9d8ef6a0db40273.fbx";